import { wrapRequest } from "./nav";
const imageLibApiUrl = import.meta.env.VITE_IMAGELIB_API_URL;
const assetNodeslsUrl = import.meta.env.VITE_APP_ASSETS_NODESLS_URL;
const vueAppMagentoApiUrl = import.meta.env.VITE_APP_MAGENTO_API_URL;
import { wrapGqlRequest } from "../services/graphqlEndPointCommonSetting/wrapGqlRequest";
import { fetchGraphQL } from "@/services/graphqlEndPointCommonSetting/fetchGraphQL";
import { PRODUCT_DETAILS_QUERY } from "./graphQl/product.queries";
export const doFetchFonts = wrapRequest(() => {
  const requestOptions = {
    method: "GET",
    headers: { "Content-type": "application/json" }
  };
  return fetch(`${imageLibApiUrl}/font?limit=10`, requestOptions);
});

export const doFetchLiners = wrapRequest((tags) => {
  const requestOptions = {
    method: "GET",
    headers: { "Content-type": "application/json" }
  };
  let res = fetch(`${imageLibApiUrl}/liner?tags=ov.{${tags}}`, requestOptions);
  return res;
});
export const doFetchColors = wrapRequest((tags) => {
  const requestOptions = {
    method: "GET",
    headers: { "Content-type": "application/json" }
  };
  let res = fetch(
    `${imageLibApiUrl}/color?tags=ov.{${tags}}&order=sort.asc`,
    requestOptions
  );
  return res;
});

export const doFetchPaperByIds = wrapRequest((paperIds) => {
  const requestOptions = {
    method: "GET",
    headers: { "Content-type": "application/json" }
  };
  let res = fetch(
    `${imageLibApiUrl}/paper?id=in.(${paperIds})`,
    requestOptions
  );
  return res;
});

export const doFetchMonogramByIds = wrapRequest((monogramIds) => {
  const requestOptions = {
    method: "GET",
    headers: { "Content-type": "application/json" }
  };
  let res = fetch(
    `${imageLibApiUrl}/monogram?id=in.(${monogramIds})`,
    requestOptions
  );
  return res;
});

export const doFetchFontByIds = wrapRequest((fontIds) => {
  const requestOptions = {
    method: "GET",
    headers: { "Content-type": "application/json" }
  };
  let res = fetch(`${imageLibApiUrl}/font?id=in.(${fontIds})`, requestOptions);
  return res;
});

/*export const doFetchProductDetails = wrapRequest((sku) => {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Authorization': 'Bearer xi7a8g1ey22veysbp6ckan4yjqqkgjys'
        },
    };
    return fetch(`${vueAppMagentoApiUrl}/rest/V2/product/${sku}`, requestOptions)
});*/
// GraphQL transformation utility
const transformProductForLegacyAPI = (gqlProduct) => {
  if (!gqlProduct) return null;

  const transformed = {
    id: gqlProduct.id,
    name: gqlProduct.name,
    sku: gqlProduct.sku,
    inStock: gqlProduct.inStock,
    status: gqlProduct?.status ?? 1,
    typeId: gqlProduct.typeId || "simple",
    description: gqlProduct.description || "",
    shortDescription: gqlProduct.shortDescription || "",
    metaTitle: gqlProduct.metaTitle || "",
    metaDescription: gqlProduct.metaDescription || "",
    urlKey: gqlProduct.urlKey || "",
    price: 0,
    options: gqlProduct?.inputOptions?.map(({ id, ...rest }) => ({
      optionId: id,
      ...rest
    })),
    unitDescription:
      gqlProduct.attributes?.find((attr) => attr.name === "unit_description")
        ?.value || "",
    builderVersion:
      gqlProduct.attributes?.find((attr) => attr.name === "builder_version")
        ?.value || "",
    isPersonalize:
      gqlProduct.attributes?.find((attr) => attr.name === "is_personalize")
        ?.value || "",
    typename: gqlProduct.__typename,
    mediaGalleryEntries:
      gqlProduct.images?.map((img, index) => ({
        id: index + 1,
        mediaType: "image",
        label: img.label || "",
        file: img.url,
        position: index + 1,
        disabled: false,
        types: img.roles || ["image"]
      })) || [],

    // Create attributes array once to avoid duplication
    customAttribute:
      gqlProduct.attributes?.map((attr) => {
        /*if (attr.name === "personalized" && attr.value === "Yes") {
                  return {
                    attributeCode: "is_personalize",
                    value: "1",
                    label: "Is Personalize",
                  };
                }*/
        return {
          attributeCode: attr.name,
          value: attr.value,
          label: attr.label
        };
      }) || [],

    relatedLinksProduct:
      gqlProduct.links
        ?.filter((link) => link.product)
        ?.map((link) => ({
          name: link.product.name,
          sku: link.product.sku,
          image:
            link.product.images?.map((img) => ({
              file: img.url,
              label: img.label
            })) || [],
          customAttribute:
            link?.product?.attributes?.map((attr) => {
              if (attr.name === "personalized" && attr.value === "Yes") {
                return {
                  attributeCode: "is_personalize",
                  value: "1",
                  label: "Is Personalize"
                };
              }
              return {
                attributeCode: attr.name,
                value: attr.value,
                label: attr.label
              };
            }) || []
        })) || [],

    configurableProductLinks:
      gqlProduct.variants?.map((variant) => ({
        id: variant?.product?.id ?? variant?.id,
        sku: variant?.product?.sku ?? variant?.sku,
        name: variant?.product?.name ?? variant?.name,
        price: variant?.price || 0,
        attributes: variant?.attributes || variant?.customAttributes || [],
        mediaGalleryEntries:
          (
            variant?.product?.media_gallery ?? variant?.mediaGalleryEntries
          )?.map((img, index) => ({
            id: index + 1,
            mediaType: "image",
            label: img.label || "",
            file: img?.url ?? img?.file,
            position: index + 1,
            disabled: false,
            types: ["image"]
          })) || [],
        customAttributes:
          (variant?.attributes ?? variant?.customAttributes)?.map((attr) => ({
            attributeCode: attr?.code ?? attr?.attributeCode,
            value: attr?.value_index ?? attr?.value,
            label: attr?.label
          })) || []
      })) || [],

    extensionAttributes: {
      categoryLinks: [],
      configurableProductLinks:
        gqlProduct.variants?.map(
          (variant) => variant?.product?.id ?? variant.id
        ) || [],
      categoryLinksPrimary: []
    },

  };

  // Extract price from GraphQL first
  let productPrice = 0;
  if (gqlProduct.price) {
    if (gqlProduct.price.final && gqlProduct.price.final.amount) {
      productPrice = parseFloat(gqlProduct.price.final.amount.value) || 0;
      transformed.price = productPrice;
    } else if (gqlProduct.price.regular && gqlProduct.price.regular.amount) {
      productPrice = parseFloat(gqlProduct.price.regular.amount.value) || 0;
      transformed.price = productPrice;
    }
    // regular price
    const regularPrice = gqlProduct.price?.regular?.amount?.value
      ? parseFloat(gqlProduct.price.regular.amount.value)
      : 0;

    // final price
    const finalPrice = gqlProduct.price?.final?.amount?.value
      ? parseFloat(gqlProduct.price.final.amount.value)
      : regularPrice;

    // finalPrice always regular
    transformed.finalPrice = regularPrice;

    // specialPrice ONLY when prices are different
    if (regularPrice !== finalPrice) {
      transformed.specialPrice = finalPrice;
    } else {
      transformed.specialPrice = 0; // or delete / undefined if you want
    }
  } else if (gqlProduct.priceRange) {
    if (
      gqlProduct.priceRange.minimum &&
      gqlProduct.priceRange.minimum.final &&
      gqlProduct.priceRange.minimum.final.amount
    ) {
      productPrice =
        parseFloat(gqlProduct.priceRange.minimum.final.amount.value) || 0;
      transformed.price = productPrice;
    }
  }

  transformed.inStock = gqlProduct.inStock;

  // Alias customAttributes to customAttribute for backward compatibility
  transformed.customAttributes = transformed.customAttribute;

  return transformed;
};
export const doFetchProductDetails = async (sku) => {
  try {
    if (!sku || sku === "") {
      throw new Error(
        `SKU is required but not provided. Received: ${JSON.stringify(sku)}`
      );
    }

    const variables = { sku: String(sku) };
    const response = await fetchGraphQL(PRODUCT_DETAILS_QUERY, variables);

    if (response?.products?.length > 0) {
      const product = transformProductForLegacyAPI(response.products[0]);
      console.log("variant_product", product);
      return { json: () => Promise.resolve([product]) };
    }

    throw new Error(`Product with SKU ${sku} not found`);
  } catch (error) {
    console.error("❌ GraphQL Product Details Error:", error);
    throw error;
  }
};
export const doFetchProductCategory = wrapRequest((catId) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: "Bearer xi7a8g1ey22veysbp6ckan4yjqqkgjys"
    }
  };
  return fetch(
    `${vueAppMagentoApiUrl}/rest/all/V1/crcategories/${catId}`,
    requestOptions
  );
});
export const doFetchProductsAttributes = wrapRequest((sku) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-type": "application/json",
      Authorization: "Bearer 58rcjzlop08412gs0xa42q3qna21zxo2",
      "Access-Control-Allow-Origin": "*"
    }
  };
  return fetch(
    `${vueAppMagentoApiUrl}/rest/all/V1/crproducts/${sku}?fields=sku,custom_attributes`,
    requestOptions
  );
});
export const doFetchCatelogProducts = wrapRequest((searchCriteria) => {
  const requestOptions = {
    method: "GET",
    headers: { "Content-type": "application/json" }
  };

  return fetch(
    `${vueAppMagentoApiUrl}/rest/V2/suggestion?q=${searchCriteria}`,
    requestOptions
  );
});
export const doFetchProductThumbnail = wrapRequest((cartId, itemId) => {
  const requestOptions = {
    method: "GET"
  };

  return fetch(
    `${assetNodeslsUrl}/cart-item-thumbnails?itemId=${itemId}&cartId=${cartId}&preview=true`,
    requestOptions
  );
});
export const doFetchProductTags = wrapRequest((sku) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-type": "application/json",
      Accept: "application/vnd.pgrst.object+json"
    }
  };
  return fetch(
    `${imageLibApiUrl}/product?sku=eq.${sku}&select=tags,sku`,
    requestOptions
  );
});
export const doFetchSessionProductDetails = async ({ sku }) => {
  const variables = { sku: String(sku) };
  const response = await fetchGraphQL(PRODUCT_DETAILS_QUERY, variables);

  if (response?.products?.length > 0) {
    const product = transformProductForLegacyAPI(response.products[0]);
    console.log("variant_product", product);
    return { json: () => Promise.resolve([product]) };
  }
};

// export const doLookupPricerDataset = wrapRequest(({ papers, uses, occassions }) => {
//     const requestOptions = {
//         method: 'POST',
//         headers: { 'Content-type': 'application/json' },
//         body: JSON.stringify({ occasions: occassions || [], papers: papers || [], uses: uses || [] })
//     };
//     return fetch(`${imageLibApiUrl}/rpc/lookup_pricer_dataset`, requestOptions);
// })
